<template>
  <div class="media-page">
    <!-- 筛选区域 -->
    <div class="filter-panel">
      <!-- 频道类型 -->
      <div class="filter-row">
        <span class="filter-label">频道类型：</span>
        <div class="filter-tags">
          <span
            class="tag-item"
            :class="{ active: filters.category_id === '' }"
            @click="setFilter('category_id', '')"
          >不限</span>
          <span
            v-for="item in categoryList"
            :key="item.id"
            class="tag-item"
            :class="{ active: filters.category_id === item.id }"
            @click="setFilter('category_id', item.id)"
          >{{ item.name }}</span>
        </div>
      </div>

      <!-- 综合门户 -->
      <div class="filter-row">
        <span class="filter-label">综合门户：</span>
        <div class="filter-tags">
          <span
            class="tag-item"
            :class="{ active: filters.title === '' && !customPortalActive }"
            @click="setPortal('')"
          >不限</span>
          <span
            v-for="portal in portalList"
            :key="portal"
            class="tag-item"
            :class="{ active: filters.title === portal && !customPortalActive }"
            @click="setPortal(portal)"
          >{{ portal }}</span>
          <el-input
            v-model="customPortal"
            placeholder="请输入门户名称"
            size="small"
            class="portal-input"
            @keyup.enter.native="applyCustomPortal"
          />
          <el-button size="small" type="primary" class="confirm-btn" @click="applyCustomPortal">确定</el-button>
        </div>
      </div>

      <!-- 新闻源 -->
      <div class="filter-row">
        <span class="filter-label">新闻源：</span>
        <div class="filter-tags">
          <span
            class="tag-item"
            :class="{ active: filters.source_id === '' }"
            @click="setFilter('source_id', '')"
          >不限</span>
          <span
            v-for="item in sourceList"
            :key="item.id"
            class="tag-item"
            :class="{ active: filters.source_id === item.id }"
            @click="setFilter('source_id', item.id)"
          >{{ item.name }}</span>
        </div>
      </div>

      <!-- 链接情况 -->
      <div class="filter-row">
        <span class="filter-label">链接情况：</span>
        <div class="filter-tags">
          <span
            class="tag-item"
            :class="{ active: filters.link_case === '' }"
            @click="setFilter('link_case', '')"
          >不限</span>
          <span
            class="tag-item"
            :class="{ active: filters.link_case === 'yes' }"
            @click="setFilter('link_case', 'yes')"
          >可带网址</span>
          <span
            class="tag-item"
            :class="{ active: filters.link_case === 'no' }"
            @click="setFilter('link_case', 'no')"
          >不可带网址</span>
        </div>
      </div>

      <!-- 发稿速度 -->
      <div class="filter-row">
        <span class="filter-label">发稿速度：</span>
        <div class="filter-tags">
          <span
            class="tag-item"
            :class="{ active: filters.outtime === '' }"
            @click="setFilter('outtime', '')"
          >不限</span>
          <span
            v-for="speed in speedList"
            :key="speed"
            class="tag-item"
            :class="{ active: filters.outtime === speed }"
            @click="setFilter('outtime', speed)"
          >{{ speed }}</span>
        </div>
      </div>

      <!-- 价格 -->
      <div class="filter-row">
        <span class="filter-label">价格区间：</span>
        <div class="filter-tags price-row">
          <!-- 快捷价格标签 -->
          <span
            class="tag-item"
            :class="{ active: activePriceTag === '' }"
            @click="setPriceTag('')"
          >不限</span>
          <span
            v-for="tag in priceTagList"
            :key="tag.label"
            class="tag-item"
            :class="{ active: activePriceTag === tag.label }"
            @click="setPriceTag(tag.label, tag.min, tag.max)"
          >{{ tag.label }}</span>
          <!-- 分隔线 -->
          <span class="price-divider">|</span>
          <!-- 自定义输入 -->
          <el-input
            v-model.number="priceMin"
            placeholder="最低价"
            size="small"
            class="price-input"
            type="number"
            @change="onPriceChange"
          />
          <span class="price-sep">—</span>
          <el-input
            v-model.number="priceMax"
            placeholder="最高价"
            size="small"
            class="price-input"
            type="number"
            @change="onPriceChange"
          />
          <span class="price-unit">元</span>
          <el-button size="small" class="reset-btn" @click="resetPrice">重置</el-button>
        </div>
      </div>

      <!-- 收起/展开 -->
      <!-- <div class="filter-toggle" @click="collapsed = !collapsed">
        <span>{{ collapsed ? '展开更多' : '收起' }}</span>
        <i :class="collapsed ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i>
      </div> -->
    </div>

    <!-- 列表区域 -->
    <div class="list-panel">
      <!-- 搜索栏 -->
      <div class="search-bar">
        <el-input
          v-model="keyword"
          placeholder="输入关键词"
          size="small"
          class="keyword-input"
          clearable
          @keyup.enter.native="doSearch"
        />
        <el-button type="primary" size="small" class="search-btn" @click="doSearch">搜索</el-button>
      </div>

      <!-- 表格 -->
      <el-table
        v-loading="loading"
        :data="tableData"
        border
        style="width: 100%"
        :header-cell-style="{ background: '#f5f7fa', color: '#555', fontWeight: '600', fontSize: '13px' }"
        :row-class-name="tableRowClassName"
      >
        <!-- <el-table-column type="selection" width="45" align="center" /> -->
        <el-table-column label="频道类型" prop="category.name" width="100" align="center" />
        <el-table-column label="媒体名称" prop="title" min-width="160" align="center">
            <template slot-scope="{ row }">
                <a
                v-if="row.urls"
                :href="row.urls"
                target="_blank"
                class="media-link"
                >{{ row.title }}</a>
                <span v-else>{{ row.title }}</span>
            </template>
        </el-table-column>
        <el-table-column label="价格(元)" prop="price" width="100" align="center">
          <template slot-scope="{ row }">
            <span class="price-text">{{ row.price }}</span>
          </template>
        </el-table-column>
        <el-table-column label="平均出稿时间" prop="outtime" width="120" align="center" />
        <el-table-column label="出稿率" prop="outrate" width="90" align="center">
          <template slot-scope="{ row }">
            {{ row.outrate }}%
          </template>
        </el-table-column>
        <el-table-column label="新闻源" prop="source_name" width="110" align="center">
          <template slot-scope="{ row }">
            <el-tag size="mini" :type="row.source_name ? 'primary' : 'info'">
              {{ row.source_name || '非新闻源' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="链接情况" prop="link_case" width="100" align="center">
          <template slot-scope="{ row }">
            <span :class="row.link_case === 'yes' ? 'link-yes' : 'link-no'">
              {{ row.link_case === 'yes' ? '可带网址' : '不可带网址' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="备注" prop="remark" min-width="180" align="center">
          <template slot-scope="{ row }">
            <span class="remark-text">{{ row.remark || '—' }}</span>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-wrap">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          :page-size="pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :current-page="currentPage"
          @current-change="handlePageChange"
          @size-change="handleSizeChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MediaList',
  data() {
    return {
      collapsed: true,

      // 筛选条件
      filters: {
        category_id: '',
        source_id: '',
        link_case: '',
        outtime: '',
        title: '',
      },

      // 综合门户
      portalList: [
        '新浪网', '搜狐网', '腾讯网', '网易网', '凤凰网', '中华网', '人民网',
        '央视网', '千龙网', '新华网', '中国网', '慧聪网', '大众网', '东方网',
        '中国日报网', '中国经济网', '中国新闻网', '中国广播网', '和讯网', '北青网',
        '光明网', '环球网', '国际在线', '中国青年网', '人民日报客户端', 'zaker号',
        '官方百家号', '荆楚网(湖北日报)', '垂直媒体', '其他门户', '海外媒体',
      ],
      customPortal: '',
      customPortalActive: false,

      // 发稿速度
      speedList: ['一小时内', '两小时内', '半天', '当天', '隔天', '2天以上'],

      // 快捷价格标签
      priceTagList: [
        { label: '0~50元',   min: 0,   max: 50  },
        { label: '51~100元', min: 51,  max: 100 },
        { label: '101~200元',min: 101, max: 200 },
        { label: '200元以上', min: 200, max: 999999 },
      ],
      activePriceTag: '',

      // 价格区间
      priceMin: '',
      priceMax: '',

      // 关键词
      keyword: '',

      // 下拉数据
      categoryList: [],
      sourceList: [],

      // 表格
      loading: false,
      tableData: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
    }
  },
  created() {
    this.fetchCategoryList()
    this.fetchSourceList()
    this.fetchList()
  },
  methods: {
    // 获取频道类型
    async fetchCategoryList() {
      try {
        const res = await this.$api.post('/api/media/mediaCategoryList')
        this.categoryList = res.data
      } catch (e) {
        console.error('获取频道类型失败', e)
      }
    },

    // 获取新闻源
    async fetchSourceList() {
      try {
        const res = await this.$api.post('/api/media/mediaSourceList')
        this.sourceList = res.data
      } catch (e) {
        console.error('获取新闻源失败', e)
      }
    },

    // 获取媒体列表
    async fetchList() {
      this.loading = true
      try {
        const params = {
          ...this.filters,
          page: this.currentPage,
          limit: this.pageSize,
        }
        if (this.keyword) params.title = this.keyword
        if (this.priceMin !== '' && this.priceMax !== '') {
            if(this.priceMin > this.priceMax){
                this.$message.error('请重新输入价格区间')
                return;
            }
          params.price_min = this.priceMin
          params.price_max = this.priceMax
        }
        // 清除空值
        Object.keys(params).forEach(k => {
          if (params[k] === '' || params[k] === null || params[k] === undefined) {
            delete params[k]
          }
        })
        const res = await this.$api.post('/api/media/mediaList', params)
        if(res.code == 1){
            const data = res.data
            this.tableData = data.data || []
            this.total = data.total || 0
        }else{
            this.$message.error(res.msg)
        }
      } catch (e) {
        console.error('获取媒体列表失败', e)
        this.$message.error('数据加载失败，请重试')
      } finally {
        this.loading = false
      }
    },

    setFilter(key, val) {
      this.filters[key] = val
      if (key === 'title') this.customPortalActive = false
      this.currentPage = 1
      this.fetchList()
    },

    setPortal(val) {
      this.customPortal = ''
      this.customPortalActive = false
      this.filters.title = val
      this.currentPage = 1
      this.fetchList()
    },

    applyCustomPortal() {
      if (!this.customPortal.trim()) return
      this.customPortalActive = true
      this.filters.title = this.customPortal.trim()
      this.currentPage = 1
      this.fetchList()
    },

    // 点击快捷价格标签
    setPriceTag(label, min, max) {
      this.activePriceTag = label
      if (label === '') {
        this.priceMin = ''
        this.priceMax = ''
      } else {
        this.priceMin = min
        this.priceMax = max
      }
      this.currentPage = 1
      this.fetchList()
    },

    onPriceChange() {
      // 手动输入时清除快捷标签高亮
      this.activePriceTag = ''
      this.currentPage = 1
      this.fetchList()
    },

    resetPrice() {
      this.priceMin = ''
      this.priceMax = ''
      this.activePriceTag = ''
      this.currentPage = 1
      this.fetchList()
    },

    doSearch() {
      this.currentPage = 1
      this.fetchList()
    },

    handlePageChange(page) {
      this.currentPage = page
      this.fetchList()
    },

    handleSizeChange(size) {
      this.pageSize = size
      this.currentPage = 1
      this.fetchList()
    },

    tableRowClassName({ rowIndex }) {
      return rowIndex % 2 === 1 ? 'stripe-row' : ''
    },
  },
}
</script>

<style scoped>
.media-page {
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  background: #f0f2f5;
  min-height: 100vh;
  padding: 16px;
  box-sizing: border-box;
}

/* 筛选面板 */
.filter-panel {
  background: #fff;
  border-radius: 6px;
  padding: 16px 20px 6px;
  margin-bottom: 14px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  position: relative;
}

.filter-row {
  display: flex;
  align-items: flex-start;
  margin-bottom: 12px;
  flex-wrap: wrap;
}

.filter-label {
  font-size: 13px;
  color: #666;
  white-space: nowrap;
  line-height: 28px;
  min-width: 70px;
  flex-shrink: 0;
}

.filter-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
  flex: 1;
}

.tag-item {
  display: inline-block;
  padding: 4px 12px;
  font-size: 12px;
  color: #555;
  border-radius: 3px;
  cursor: pointer;
  line-height: 20px;
  transition: all 0.15s;
  user-select: none;
  white-space: nowrap;
}

.tag-item:hover {
  color: #1890ff;
}

.tag-item.active {
  background: #1890ff;
  color: #fff;
  font-weight: 500;
}

.portal-input {
  width: 130px;
}

.portal-input >>> .el-input__inner {
  height: 28px;
  line-height: 28px;
  font-size: 12px;
}

.confirm-btn {
  height: 28px;
  padding: 0 10px;
  font-size: 12px;
}

/* 价格 */
.price-row {
  align-items: center;
}

.price-input {
  width: 90px;
}

.price-input >>> .el-input__inner {
  height: 28px;
  line-height: 28px;
  font-size: 12px;
}

.price-sep {
  font-size: 13px;
  color: #aaa;
  padding: 0 4px;
}

.price-unit {
  font-size: 12px;
  color: #888;
  margin-left: 4px;
}

.reset-btn {
  height: 28px;
  padding: 0 10px;
  font-size: 12px;
  margin-left: 6px;
}

/* 收起/展开 */
.filter-toggle {
  text-align: center;
  font-size: 12px;
  color: #1890ff;
  cursor: pointer;
  padding: 6px 0 8px;
  user-select: none;
  border-top: 1px dashed #e8e8e8;
  margin-top: 4px;
}

.filter-toggle i {
  margin-left: 4px;
}

/* 列表面板 */
.list-panel {
  background: #fff;
  border-radius: 6px;
  padding: 16px 20px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
}

/* 搜索栏 */
.search-bar {
  display: flex;
  align-items: center;
  margin-bottom: 14px;
  gap: 8px;
}

.keyword-input {
  width: 200px;
}

.keyword-input >>> .el-input__inner {
  height: 32px;
  line-height: 32px;
}

.search-btn {
  height: 32px;
}

/* 价格文字 */
.price-text {
  color: #f5222d;
  font-weight: 600;
  font-size: 13px;
}

/* 链接情况 */
.link-yes {
  color: #1890ff;
  font-size: 12px;
}

.link-no {
  color: #999;
  font-size: 12px;
}

/* 备注 */
.remark-text {
  font-size: 12px;
  color: #888;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* 斑马纹 */
.media-page >>> .stripe-row {
  background: #fafafa;
}

/* 分页 */
.pagination-wrap {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}

/* 表格字体 */
.media-page >>> .el-table {
  font-size: 13px;
  color: #444;
}

.media-page >>> .el-table td {
  padding: 8px 0;
}
</style>